import { removePunctuation } from './remove-punctuation';

export const isMatchingString = (a: string, b: string): boolean =>
  Boolean(removePunctuation(a.toLowerCase()).match(removePunctuation(b.toLowerCase())));
